import { h } from "@stencil/core";
import { SALUTATION } from "../../../api/salutation";
import { getCountryFromLocale, getLanguageFromLocale } from "../../../utils/locale";

export const SalutationInput = ({ t, prefillData }) => (
    <ux-select label={t("field.salutation.label")} required name="salutation">
        <option value="" selected={typeof prefillData?.callBackContact.salutation !== "number"} disabled>
            {t("select.placeholder")}
        </option>
        <option value={SALUTATION.FEMALE} selected={prefillData?.callBackContact.salutation === SALUTATION.FEMALE}>
            {t("field.salutation.female")}
        </option>
        <option value={SALUTATION.MALE} selected={prefillData?.callBackContact.salutation === SALUTATION.MALE}>
            {t("field.salutation.male")}
        </option>
    </ux-select>
);

export const FirstNameInput = ({ t, prefillData }) => (
    <ux-input-field
        data-validation-required--msg={t("validation.requiredField")}
        data-validation-length--max="45"
        data-validation-length--msg={t("validation.maxAllowedCharacters", {
            number: 45
        })}
        label={t("field.firstName.label")}
        name="firstName"
        value={prefillData?.callBackContact.firstName}
        required
    ></ux-input-field>
);

export const LastNameInput = ({ t, prefillData }) => (
    <ux-input-field
        data-validation-required--msg={t("validation.requiredField")}
        data-validation-length--max="45"
        data-validation-length--msg={t("validation.maxAllowedCharacters", {
            number: 45
        })}
        label={t("field.lastName.label")}
        name="lastName"
        value={prefillData?.callBackContact.lastName}
        required
    ></ux-input-field>
);

export const PhoneInput = ({ t, prefillData, locale }) => (
    <ux-phone-input
        label={t("field.phone.label")}
        language={getLanguageFromLocale(locale)}
        country={getCountryFromLocale(locale)}
        data-validation-invalid--msg={t("validation.invalidPhoneNumber")}
        data-validation-required--msg={t("validation.requiredField")}
        name="phone"
        value={prefillData?.callBackContact.phone}
        required
    />
);

export const EmailInput = ({ t, prefillData }) => (
    <ux-input-field
        type="email"
        required
        data-validation-required--msg={t("validation.requiredField")}
        data-validation-length--max="100"
        data-validation-length--msg={t("validation.maxAllowedCharacters", {
            number: 100
        })}
        data-validation-invalid--msg={t("validation.invalidEmail")}
        label="E-Mail"
        name="email"
        value={prefillData?.callBackContact.email}
    ></ux-input-field>
);
